import {
  LOADING_MESSAGE_ACTIONS,
  LOADING_MESSAGE_SUBJECTS,
} from '../constants';

// Shuffle array helper
const shuffleArray = <T>(array: T[]): T[] => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

// Keep track of shuffled pools
let actionPool: string[] = [];
let subjectPool: string[] = [];
let lastMessage = '';

/**
 * Generates a random loading message by combining a random action with a random subject.
 * Uses a shuffled pool approach to ensure variety and prevent immediate repeats.
 * @returns A randomly generated loading message string (e.g., "Analyzing trends...")
 */
export const generateLoadingMessage = (): string => {
  // Refill and shuffle pools when empty
  if (actionPool.length === 0) {
    actionPool = shuffleArray(LOADING_MESSAGE_ACTIONS);
  }
  if (subjectPool.length === 0) {
    subjectPool = shuffleArray(LOADING_MESSAGE_SUBJECTS);
  }

  // Pop from pools
  const action = actionPool.pop()!;
  const subject = subjectPool.pop()!;
  const newMessage = `${action} ${subject}...`;

  // If by chance we got the same message, try one more time
  if (newMessage === lastMessage && actionPool.length > 0 && subjectPool.length > 0) {
    const retryAction = actionPool.pop()!;
    const retrySubject = subjectPool.pop()!;
    lastMessage = `${retryAction} ${retrySubject}...`;
    return lastMessage;
  }

  lastMessage = newMessage;
  return newMessage;
};
